import { Box } from "@otrium/core";
import { Skeleton } from "src/atoms/Skeleton";

const CheckoutOrderSummarySkeleton = ({
  width,
}: {
  width?: number | string | (number | string)[];
}): JSX.Element => (
  <Box height={480} width={width || "100%"}>
    <Skeleton />
  </Box>
);

export default CheckoutOrderSummarySkeleton;
